import SelectionStatus from 'portfolio/components/SelectionStatus';
import React from 'react';

import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import DarkVenueHeatmapHelp from 'widgets/darkVenueHeatmap/DarkVenueHeatmapHelp.tsx';

export default function DarkVenueHeatmapToolbar() {
    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    return (
        <WidgetToolbarShowHidePanel mustShow={!hasValidSelection}>
            <div className="DarkVenueHeatmapToolbar panel-header">
                <div className="toolbar">
                    <SelectionStatus
                        widgetName="Dark Venue Heatmap Widget"
                        selectionRequirements={portfolioSelectionRequirements}
                    />
                </div>
                {hasValidSelection && (
                    <WidgetToolbar
                        preceedingItems={
                            <>
                                <DarkVenueHeatmapHelp />
                            </>
                        }
                    />
                )}
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
